// Acciones asincronas que pueden llamar una inforrmacion

import { LoginUser, GetUserRecords, GetDataCatalog, GetDatosPersonales, insertAlumnoService, generarComprobanteService, registraDocumentosService, consultaDocumentosService } from "../helpers/services";

export const verifyUser = async ({ commit }, values) => {
  const { data } = await LoginUser(values);
  if (Object.keys(data).length !== 0) {
    commit("setUser", { ...data, cuenta: values.cuenta });
    return data;
  }
};

export const getRecords = async ({ commit }, values) => {
  const { data } = await GetUserRecords(values);
  if (Object.keys(data).length !== 0) {
    //commit("setUser", data);
    return data;
  }
};

export const getDataCatalog = async ({ commit }, values) => {
  const { data } = await GetDataCatalog(values);
  if (Object.keys(data).length !== 0) {
    //commit("setUser", data);
    return data;
  }
};

export const getDatosPersonales = async ({ commit }, values) => {
  const { data } = await GetDatosPersonales(values);
  if (Object.keys(data).length !== 0) {
    //commit("setUser", data);
    return data;
  }
};

export const insertAlumno = async ({ commit }, values) => {
  const { data } = await insertAlumnoService(values);
  if (Object.keys(data).length !== 0) {
    commit("setIdRegistro", data);
    return data;
  }
};

export const generarComprobante = async ({ commit }, values) => {
  const { data } = await generarComprobanteService(values);
  if (Object.keys(data).length !== 0) {
    //commit("setUser", data);
    return data;
  }
};

export const consutaDocumentos = async ({ commit }, values) => {
  const { data } = await consultaDocumentosService(values);
  return data
  // if (Object.keys(data).length !== 0) {
  //   //commit("setUser", data);
  //   return data;
  // }
};

export const registraDocumentos = async ({ commit }, values) => {
  const { data } = await registraDocumentosService(values);
  if (Object.keys(data).length !== 0) {
    //commit("setUser", data);
    return data;
  }
};

export const actualizaRespuestas = async ({ commit }, respuestas) => {
  commit("setCuestionario", respuestas);
};

export const logOut = async ({ commit }) => {
  commit("clearState");
};

export const loader = ({ commit }, value) => {
  commit("verificaLoader", value);
};

export const actualizaIdRegistro = ({ commit }, value) => {
  commit("setIdRegistro", value);
};